import axios from "../../../util/axios";

export default {
    /** 开通哪些服务 */
    queryAllService: () => axios.get({url: "/basedata/system/setting/queryAllService"}),
    /** 查询配置项 */
    getSetting: () => axios.get({url: "/basedata/system/setting/getSetting"}),
    /** 配置项保存 */
    saveSetting: (data) => axios.post({url: "/basedata/system/setting/saveSetting", data: data}),
    /** 配置项变更时，提交回调 */
    settingCallback: (callBack, data) => axios.post({url: `/basedata/system/setting/settingCallback?callBack=${callBack}`, data}),

}